import { render, staticRenderFns } from "./__TemBich.vue?vue&type=template&id=63febafc&"
import script from "./__TemBich.vue?vue&type=script&lang=js&"
export * from "./__TemBich.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports